// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4381":"ba44bf83aca0bc1c","8778":"512e289e394b0035"}[chunkId] + ".css";
};